import { render } from "./TressVideoPlayer.vue?vue&type=template&id=1336462a&ts=true"
import script from "./TressVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./TressVideoPlayer.vue?vue&type=script&lang=ts"

import "./TressVideoPlayer.vue?vue&type=style&index=0&id=1336462a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__